import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DocumentListWithDetails from 'components/HealthRecords/Documents/DocumentListWithDetails';
import { DefaultDivider } from 'services/UIUtils';
import AddDocument from 'components/HealthRecords/Documents/AddDocument';
import DefaultModal from 'components/Utils/DefaultModal';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { TopBar } from 'components/Patient/CPP/CPPInput/Inputs/CPPInputCommonViews';
import './style.scss';
import PrescriptionsList from 'components/HealthRecords/Prescriptions/PrescriptionsList/index';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import DocumentUtils from 'services/DocumentUtils';
import _ from 'lodash';

const DONT_INCLUDE = [DocumentUtils.DOCUMENT_TYPE.export, DocumentUtils.DOCUMENT_TYPE.template];

const CPPDocumentsInputView = (props) => (
  <div className="cpp-input cpp-documents-input">
    {props.onClose && <TopBar title="Documents" onClose={props.onClose} />}
    <DocumentTypeSelector
      selected={props.selected}
      selectDocumentType={props.selectDocumentType}
      setAddingDocument={props.setAddingDocument}
    />

    <DefaultDivider className="documents-divider" />

    {props.selected === 'prescription' && (
      <PrescriptionsList patient={props.patient} prescriptions={props.prescriptions} />
    )}

    {props.selected !== 'prescription' && (
      <DocumentListWithDetails
        key={props.selected}
        patient={props.patient}
        documents={props.documents}
        disableEdit={props.disableEdit}
        disablePatientBadge={true}
        autoLoad={true}
        allowExpand={true}
        allowDelete={true}
        allowPin={true}
      />
    )}

    <AddDocumentModal {...props} />
  </div>
);

CPPDocumentsInputView.propTypes = {
  patient: PropTypes.object.isRequired,
  documents: PropTypes.array.isRequired,
  selectDocumentType: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  selected: PropTypes.string,
  disabledEdit: PropTypes.bool,
  options: PropTypes.array,
};

const DocumentTypeSelector = ({ selected, selectDocumentType, setAddingDocument }) => {
  const options = useMemo(() => getDocumentTypeOptions(), []);

  return (
    <div className="document-type-selector">
      <DefaultSelectField
        name="document_type"
        placeholder="Document Type"
        value={selected}
        style={{ width: '300px', marginTop: 0, marginRight: '15px' }}
        onChange={(event) => {
          selectDocumentType(event.target.value);
        }}
        inputElements={options.map((option) => (
          <MenuItem id={'menu-item-' + option.value} value={option.value} key={option.value}>
            {option.label}
          </MenuItem>
        ))}
      />
      <div className="button-wrapper">
        <DefaultButton
          name="Upload"
          icon="upload"
          className="blue"
          onClick={() => setAddingDocument(true)}
        />
      </div>
    </div>
  );
};

const AddDocumentModal = (props) =>
  props.addingDocument && (
    <DefaultModal
      className="modal fit-modal fit-width"
      key="add-document-modal"
      title="Add Document"
      content={
        <AddDocument
          patient={props.patient}
          onSave={() => props.setAddingDocument(false)}
          onClose={() => props.setAddingDocument(false)}
        />
      }
      isOpen={true}
      onRequestClose={() => props.setAddingDocument(false)}
    />
  );

function getDocumentTypeOptions() {
  let results = Object.keys(DocumentUtils.DOCUMENT_TYPE)
    .filter((key) => !DONT_INCLUDE.includes(DocumentUtils.DOCUMENT_TYPE[key]))
    .map((key) => {
      return {
        value: key,
        label: DocumentUtils.DOCUMENT_TYPE[key],
      };
    });
  results.push({ label: 'Prescription', value: 'prescription' });
  results = [{ label: 'All', value: 'all' }, ..._.sortBy(results, 'label')];
  return results;
}

export default CPPDocumentsInputView;
